import { render, staticRenderFns } from "./teamsize.vue?vue&type=template&id=2e88530a&scoped=true"
import script from "./teamsize.vue?vue&type=script&lang=js"
export * from "./teamsize.vue?vue&type=script&lang=js"
import style0 from "./teamsize.vue?vue&type=style&index=0&id=2e88530a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e88530a",
  null
  
)

export default component.exports